import * as React from "react";
import { Select } from "antd";
import BaseUI, { IBaseUI } from "src/engine/ui/BaseUI";
import UIManifest from "src/engine/ui/UIManifest";
import { province, city } from "./citymap";
import { changeCodeToCity } from "./codeToCity";
import "./JCityChoose.scss";

const { Option } = Select;

interface IJA extends IBaseUI {
    //地址
    href: string;
    // 2.2.19
    target: string;
    value?: any;
    onChange?: any;
    disabled?: boolean;
    width?: string;
    itemStyle?: any;
    optionItemStyle?: any;
    isText?: boolean;
    useName?: boolean;
}
interface IState { }

@UIManifest.declare("JCityChoose", "省市选择PC端", UIManifest.Type.JJ)
class JCityChoose extends BaseUI<IJA, IState> {

    popContainerRef: React.RefObject<HTMLDivElement> = React.createRef();

    state = {
        provCode: "",
        cities: [],
        cityCode: null,
    };

    provCode: string;
    handleProvinceChange = (prov: string) => {
        const { onChange } = this.props;
        onChange(void 0);
        this.setState({
            cities: city[prov] || [],
            provCode: prov,
            cityCode: null,
        });
    };

    onSecondCityChange = (cit: string) => {
        const { onChange, useName } = this.props;
        this.setState({
            cityCode: cit,
        });
        if (this.state.provCode) {
            if (useName) {
                onChange?.(changeCodeToCity(`${this.state.provCode},${cit}`));
            } else {
                onChange?.(`${this.state.provCode},${cit}`);
            }
        }
    };

    getProps = () => {
        const { value = "", disabled, width = 120, itemStyle = {} } = this.props;
        const defaultProps = { disabled, style: { width, ...itemStyle } };
        const pprop: any = { ...defaultProps, placeholder: "请选择省份" },
            cprops: any = { ...defaultProps, placeholder: "请选择城市" };
        if (value) {
            const ar = value.split(",");
            if (ar[0]) {
                pprop.value = ar[0];
                this.setState({
                    cities: city[ar[0]] || [],
                    provCode: ar[0],
                    cityCode: null,
                });
            }
            if (ar[1]) cprops.value = ar[1];
        }
        if (this.state.provCode) {
            pprop.value = this.state.provCode;
        }
        if (this.state.cityCode) {
            cprops.value = this.state.cityCode;
        }
        return { pprop, cprops };
    };

    renderSelect() {
        const { pprop, cprops } = this.getProps();
        const { optionItemStyle = {} } = this.props;
        return (
            // 通过ref和getPopupContainer防止下拉弹窗固定在页面
            <div className="ant-city-select" style={{ position: 'relative' }} ref={this.popContainerRef} >
                <Select {...pprop} onChange={this.handleProvinceChange} getPopupContainer={() => this.popContainerRef.current}>
                    {province.map((p) => (
                        <Option key={p.value} value={p.value} style={optionItemStyle}>
                            {p.label}
                        </Option>
                    ))}
                </Select>
                <Select {...cprops} onChange={this.onSecondCityChange} getPopupContainer={() => this.popContainerRef.current}>
                    {this.state.cities.map((c: any) => (
                        <Option key={c.value} value={c.value} style={optionItemStyle} >
                            {c.label}
                        </Option>
                    ))}
                </Select>
            </div>
        );
    }

    renderText() {
        const { value } = this.props;
        if (!value) return null;
        const str = changeCodeToCity(value);
        return <div>{str}</div>;
    }

    render() {
        const { isText } = this.props;
        return isText ? this.renderText() : this.renderSelect();
    }
}

export default JCityChoose;
